import { createSlice } from '@reduxjs/toolkit';

const initialState = 2025;

const rutaYearFilterSlice = createSlice({
	name: 'rutaYearFilterState',
	initialState,
	reducers: {
		setRutaFilterYear: (state, action) => {
			return action.payload;
		}
	}
});

export const { setRutaFilterYear } = rutaYearFilterSlice.actions;

export default rutaYearFilterSlice.reducer;
